import { render, staticRenderFns } from "./MessageVariables.vue?vue&type=template&id=f1a6aac0&scoped=true"
import script from "./MessageVariables.vue?vue&type=script&lang=js"
export * from "./MessageVariables.vue?vue&type=script&lang=js"
import style0 from "./MessageVariables.vue?vue&type=style&index=0&id=f1a6aac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a6aac0",
  null
  
)

export default component.exports